(() => {
  const initCollectionShell = (shell) => {
    if (!shell || shell.dataset.avReady === 'true') return;

    const filters = shell.querySelector('[data-collection-filters]');
    const openButton = shell.querySelector('[data-filter-open]');
    const closeButton = shell.querySelector('[data-filter-close]');
    const overlay = shell.querySelector('[data-filter-overlay]');
    const focusTarget = filters ? filters.querySelector('input, button, select, textarea, a[href]') : null;
    let lastTrigger = null;

    if (!filters || !openButton) {
      shell.dataset.avReady = 'true';
      return;
    }

    const openDrawer = () => {
      lastTrigger = document.activeElement;
      shell.dataset.filtersOpen = 'true';
      overlay.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('av-no-scroll');

      window.requestAnimationFrame(() => {
        if (focusTarget) focusTarget.focus();
      });
    };

    const closeDrawer = () => {
      shell.dataset.filtersOpen = 'false';
      overlay.hidden = true;
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('av-no-scroll');

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    };

    openButton.addEventListener('click', openDrawer);
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shell.dataset.filtersOpen === 'true') {
        closeDrawer();
      }
    });

    shell.dataset.avReady = 'true';
  };

  const boot = (scope = document) => {
    document.documentElement.classList.add('js');
    scope.querySelectorAll('[data-collection-shell]').forEach(initCollectionShell);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
